export const getDisplayLabelSuffix = (number) => (number === 1 ? "" : "s")